import React from 'react'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from "@material-ui/core/IconButton"
const ITEM_HEIGHT = 48;

export default class WorkorderItemEditmenu extends React.PureComponent {

    state = {
        anchorEl: null,
    };

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = (ev) => {
        this.setState({ anchorEl: null });
    };

    handleDate = () => {
        this.handleClose();
        this.props.handleDate();
    }

    handleProject = () => {
        this.handleClose();
        this.props.handleProject();
    }

    handleDelete = () => {
        this.handleClose();
        this.props.handleDelete();
    }

    handleSignature = () => {
        if (document.documentElement) { document.documentElement.scrollTop = 0 }
        this.handleClose();
        this.props.handleSignature();
    }

    handleFileUpload = () => {
        document.getElementById(this.props.fileUploadId).click();
        this.handleClose();
    }

    render() {
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);

        return (
            <div style={this.props.style}>
                <IconButton
                    aria-label="More"
                    aria-owns={open ? 'long-menu' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleClick}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={this.handleClose}
                    PaperProps={{
                        style: {
                            maxHeight: ITEM_HEIGHT * 6,
                            width: 250,
                        },
                    }}
                >
                    <MenuItem onClick={this.handleDate}>
                        Datum wijzigen
                        </MenuItem>

                    {this.props.orderItem.setautograph
                        && <MenuItem onClick={this.handleSignature}>
                            Handtekening toevoegen
                    </MenuItem>
                    }

                    <MenuItem onClick={this.handleFileUpload}>
                        Document toevoegen
                        </MenuItem>
                    <MenuItem onClick={this.handleProject}>
                        Project wijzigen
                        </MenuItem>
                    <MenuItem onClick={this.handleDelete}>
                        Verwijderen
                        </MenuItem>

                </Menu>
            </div>
        )
    }
}
